export const themeNames = {
    NEWS: 'News',
    PLAYER: 'Player',
    FACT: 'Fact',
    STANDALONE_FACT: 'Standalone Fact',
    TWITTER: 'Twitter',
    INSTAGRAM: 'Instagram',
    FACEBOOK: 'Facebook'
};

export default {
    themeNames
};
